import { h, Component } from "preact";
import $ from "jquery";

import GlobState from 'globstate'
import Globals from '../globals.js'

import { useContext } from 'preact/hooks';
import { TranslateContext } from '@denysvuika/preact-translate';

class Home extends Component {
  constructor(props) {
    super(props);    
    let answered = 0;
    let counters = {
      templates: 0,
      err: 0,
      exp: 0,
    }

    let templates = Globals.Templates();
    let correctId = '';
    let isCorrect = false;
    let templateId;
    let myFavs;
    let answers;
    let usedExp;
    let $anstemplates = 0;

    Object.keys(templates).map((tmp) => {
      templateId = (parseInt(tmp) + 1)
      myFavs = JSON.parse(localStorage.getItem('favs_' + templateId))
      answers = JSON.parse(localStorage.getItem('answers_' + templateId));
      usedExp = JSON.parse(localStorage.getItem('exp_' + templateId));

      Object.keys(templates[tmp].questions).map((i) => {
        let question = templates[tmp].questions[i];
        if (answers && answers[question.id]) {
          correctId = question.correctId;
          isCorrect = (correctId == answers[question.id]);
          if (isCorrect) {
            answered++;
          } else {
            counters.err++;
          }
        }
        if (usedExp && usedExp[question.id]) {
          counters.exp++;
        }
      })
      if (answers && Object.keys(answers).length == 20) {
        $anstemplates = $anstemplates + 1;
      }
    })

    // marathon_answers_1

    this.state = {
      anstemplates: $anstemplates,
      // ansmarathon: $marathonanswers,
    };
  }

  componentDidMount() {

  }

  render() {
    const { setLang, t, lang } = useContext(TranslateContext);

    return (
      <section class="menu_home">

        <div class="menu_icon">
        </div>

        <div class="d-flex justify-content-center flex-column align-items-center">
          <span class="menu_h1">
            {t("Home.title")}
          </span>
          <span class="gray_text">
            {t("Home.text")}
          </span>
        </div>
 
      <div>

        <div class="d-flex flex-column mt-3">
          <img src="/assets/images/bg3.png" alt="" />
        </div>

        <div class="home_buttons mt-3">
          <a class="btn btn-primary" href="/templates/" role="button">{t("Home.0")}</a>
          <a class="btn btn-primary" href="/marathon/" role="button">{t("Home.1")}</a>
          <a class="btn btn-warning" href="/fav/" role="button">{t("Home.2")}</a>
          <a class="btn btn-danger" href="/test/" role="button">{t("Home.3")}</a>
          <a class="btn btn-info" href="/rules/" role="button">{t("Home.5")}</a>
          {/* <a class="btn btn-light btn-lg" href="/lib/" role="button">{t("Home.4")}</a> */}
        </div>

        </div>  
        
      </section>
    );
  }
}

export default GlobState.connect(Home, Globals)